import Vue from 'vue';
import Card from 'src/components/Card/Card';
export default Vue.extend({
    components: { Card },
    data() {
        return {
            visible: false,
            value: '',
            inputHandler: () => ({}),
            componentProps: {}
        };
    },
    methods: {
        openDialog(params) {
            this.visible = true;
            this.value = params.currentValueParam || '';
            this.inputHandler = params.handleSelectorValueSelection || (() => ({}));
            this.componentProps = params.componentProps || {};
        }
    }
});
